import { apiClient } from "./client";

/**
 * Request payload for sending email with Excel file
 */
export interface SendEmailRequest {
  excelFile: File | Blob;
  emailAddress: string;
  subject?: string;
  message?: string;
  projectName?: string;
}

/**
 * Response from email API
 */
export interface SendEmailResponse {
  success: boolean;
  message?: string;
  emailId?: string;
}

/**
 * Email API
 * Handles sending emails with Excel file attachments
 */
export const emailApi = {
  /**
   * Send email with Excel file attachment
   * @param data - SendEmailRequest containing file and email details
   * @returns Promise<SendEmailResponse>
   */
  sendEmail: async (data: SendEmailRequest): Promise<SendEmailResponse> => {
    // Create FormData for file upload
    const formData = new FormData();
    formData.append("excelFile", data.excelFile);
    formData.append("emailAddress", data.emailAddress);

    if (data.subject) {
      formData.append("subject", data.subject);
    }

    if (data.message) {
      formData.append("message", data.message);
    }

    if (data.projectName) {
      formData.append("projectName", data.projectName);
    }

    const response = await apiClient.post<SendEmailResponse>(
      "/email/send",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  },
};
